
        ;
        'use strict';

var $ = window.$;
var sidebarAds = $('.sidebar-ad a');
for (var i = 0; i < sidebarAds.length; i++) {
    var flag = sidebarAds.eq(i).attr('data-flag');
    if (flag == '1') sidebarAds.eq(i).addClass('ad');
};
    


// WEBPACK FOOTER //
// ./src/module/home-list/sidebar-ad/index.js